import { Button, Card, Col, Row, Typography } from "antd";
import { useFlow, FLOWS } from "hook/draft/dialog/flow/useFlow";
import React from "react";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
import empty from "asset/img/bailiff/working.png";
import { GrTrigger } from "react-icons/gr";
import { useDialogTaken } from "hook/draft/dialog/action/useDialogTaken";
const TaskEmpty = () => {
  // -------------------------- VAR -----------------------------
  const { flow } = useFlow();
  const { disabled, loading, handleTakeTask } = useDialogTaken();
  const isFlow = flow === FLOWS.EMPTY;

  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  if (!isFlow) return null;
  return (
    <Card>
      <Row>
        <Col xl={24} lg={24} md={24} xs={24}>
          <Typography.Title level={4}>
            Mọi người đã bắt đầu vào việc
          </Typography.Title>
          <Typography.Paragraph>
            <p>
              Nhấn vào "Nhận việc mới" để bắt đầu công việc. Chỉnh sửa lại đoạn
              văn theo đúng mẫu câu nghe được trong audio.
            </p>
            <p>
              Với mỗi lần nhận việc, bạn sẽ phải hoàn thành 5 đoạn audio bất kỳ.
              Sau khi hoàn thành, bạn sẽ được ghi nhận điểm nỗ lực và thù lao
              tương ứng với cam kết trước đó
            </p>
          </Typography.Paragraph>
        </Col>
        <Col xl={24} lg={24} md={24} xs={24}>
          <img src={empty} style={{ width: 300, height: 300 }} alt="working" />
        </Col>
        <Col xl={24} lg={24} md={24} xs={24}>
          <Button
            loading={loading}
            type="primary"
            style={{ width: 300 }}
            icon={
              <span className="anticon">
                <GrTrigger />
              </span>
            }
            block
            onClick={handleTakeTask}
            disabled={disabled}
          >
            Nhận việc mới
          </Button>
        </Col>
      </Row>
    </Card>
  );
};
export default TaskEmpty;
